import { gql, useMutation } from "@apollo/client";

const LOGOUT = gql(`
mutation UserLogout {
    userLogout
}
`);

export default function useLogoutQuery() {
    const [logout, { loading, error }] = useMutation(LOGOUT);

    return {
        loading,
        error,
        logout,
    };
}
